import NotesSection from './NotesSection';

export default NotesSection;
